import $ from "/srv/www/kisgroup.websiteomgeving.nl/vhosts/www/htdocs/wp-content/plugins/wp-soup-framework/node_modules/jquery";

$(document).ready(function () {
  setTimeout(function () {
    document.querySelectorAll(".mega-menu").forEach((megaMenu) => {
      const firstNested = megaMenu.querySelector(
        ".mega-sub-menu.submenu.is-dropdown-submenu"
      );

      if (firstNested) {
        firstNested.classList.add("kisgroup-mega-menu-ul");
        console.log("firstNested:", firstNested);
      }
    });
  }, 500);
});

document.querySelectorAll(".mega-menu").forEach((megaMenu) => {
  const firstNested = megaMenu.querySelector(
    ".mega-sub-menu.submenu.is-dropdown-submenu"
  );

  if (firstNested) {
    firstNested.classList.add("kisgroup-mega-menu-ul");
    console.log("firstNested 2", firstNested);
  }
});
